import { useEffect, useState } from "react";
import {
    Alert, Box,
    Button,
    Checkbox,
    Chip,
    Fade,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    InputAdornment,
    Modal,
    Paper,
    Stack,
    styled,
    TextField, Tooltip,
    Typography
} from "@mui/material";
import { useUser } from "../../../lib/hooks";
import LoginModal from "../../common/loginModal";
import {createFolder, deleteFolder, getUserInformation, pay, shareFiles, shareFolder} from "../../../lib/services/drive";
import Toasty from "../../../theme/components/Toasty";
import { LoadingButton } from "../../../theme/components/LoadingButton";
import {
    CloseRounded,
    ContentCopyRounded,
    DoneRounded,
    InfoRounded,
    QuestionMark,
    QuestionMarkRounded,
    Twitter,
    VisibilityOffRounded,
    VisibilityRounded
} from "@mui/icons-material";
import { NumericFormatCustom } from "../../common/formatInputs";
import AddressBookModal from "../../common/addressBookModal";
import { validateEmail, validatePhoneNumber } from "../../../lib/commonFunctions/regexValidators";
import { FarsiDateTimePicker } from "../../common/farsiDatePicker";
import InputFieldModal from "../../dashboard/drive/inputFieldModal";

const ShareFileModal = (props) => {

    const { onClose = () => null, onConfirm = () => null, files, setFiles, folderId, shareType, ...restProps } = props;
    const [inputsData, setInputsData] = useState({
        title: '',
        description: '',
        isPublic: false,
        isFree: true,
        price: '',
        isHavePassword: false,
        password: '',
        showPassword: false,
        isHaveExpire: false,
        expireDate: new Date(),
        isNeedToLogin: false,
        receiver: '',
        receiverError: false,
    });
    const [receiversList, setReceiversList] = useState([]);
    const [receiverError, setReceiverError] = useState('');
    const [expireDateError, setExpireDateError] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [pending, setPending] = useState(false);
    const [linkAddress, setLinkAddress] = useState('');
    const [success, setSuccess] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const [addBalanceModal, setAddBalanceModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const [addressBookModalOpen, setAddressBookModalOpen] = useState(false);
    const [successShareModalOpen, setSuccessShareModalOpen] = useState(false);

    const user = useUser();

    const handleClose = () => {
        setAnchorEl(null);
    };
    // Inputs
    const handleInputChange = (e) => {
        const { target: { value, name } } = e;
        setInputsData({ ...inputsData, [name]: value });
    }
    const handleCheckboxChange = (e) => {
        const { target: { checked, name } } = e;
        setInputsData({ ...inputsData, [name]: checked });
    }
    const handleGotoBalancePayment = async (amount) => {
        setPending(true);
        try {
            const { data } = await pay('balance', { amount });
            if (data?.isSuccess) {
                if (data.value?.gatewayUrl) window.location.href = data.value.gatewayUrl;
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setPending(false);
    }
    const handleAddReceiver = (e, item) => {
        e?.preventDefault();
        setReceiverError('');
        let receiver;
        if (item) receiver = item; else receiver = inputsData.receiver;
        if (!receiver) return setReceiverError('مقدار دریافت کننده نمی تواند خالی باشد');
        if (Boolean(validateEmail(receiver)) || Boolean(validatePhoneNumber(receiver))) {
            if (receiversList.find(r => r === receiver)) return setReceiverError('دریافت کننده ای که وارد کرده اید در لیست حضور دارد')
            setReceiverError(false);
            setReceiversList([...receiversList, receiver]);
            setInputsData({ ...inputsData, receiver: "" });
        } else setReceiverError('مقدار وارد شده باید یا ایمیل یا شماره (به حروف لاتین) باشد')
    }
    const handleAddReceivers = (receivers) => {
        if (!receivers.length) return;
        setReceiverError('');
        const newReceivers = [...receiversList];
        receivers.forEach(receiver => {
            if (receiversList.find(r => r === receiver)) return;
            newReceivers.push(receiver);
        });
        setReceiversList(newReceivers);
    }
    const handleRemoveReceiver = (receiver) => {
        setReceiversList(receiversList.filter(r => r !== receiver));
    }
    const handleRemoveFile = (file) => {
        const newFiles = files.filter(f => f !== file)
        setFiles(newFiles);
        if (!newFiles.length) onClose();
    }

    const handleSubmit = async (e, isLoggedIn) => {
        if (!user && !isLoggedIn) return setLoginModalOpen(true);
        if (inputsData.isHaveExpire && expireDateError) return Toasty.error('تاریخ انقضای وارد شده صحیح نمی باشد');
        if (!inputsData.isPublic && !receiversList.length) return Toasty.error('لیست گیرندگان را بصورت صحیح وارد کنید')
        setPending(true);
        switch (shareType) {
            case "newFolder": {
                try {
                    if (files.length) {
                        const folderName = `shared-${new Date().getTime()}`
                        const data = await createFolder(0, folderName);
                        if (data?.isSuccess) {
                            const folderId = data.value;
                            const {
                                title,
                                description,
                                isPublic,
                                isNeedToLogin,
                                price,
                                password,
                                isHaveExpire,
                                isHavePassword,
                                isFree,
                                expireDate,
                            } = inputsData;
                            const { data: shareData } = await shareFolder({
                                folderId,
                                title,
                                description,
                                isPublic,
                                password: isHavePassword ? password : undefined,
                                expireDate: isHaveExpire ? expireDate?.toISOString().slice(0, 10).replace(/-/g, "-") : undefined,
                                downloadPrice: !isFree && price,
                                isNeedRegister: isNeedToLogin,
                                ReciverNames: !isPublic ? receiversList : undefined,
                            });
                            if (shareData?.isSuccess) {
                                const { linkAddress } = shareData.value;
                                onConfirm(folderId, linkAddress);
                            }
                            else {
                                if (shareData && shareData.errors?.length) {
                                    setPending(false);
                                    shareData.errors.map(i => Toasty.error(i));
                                    return await deleteFolder(folderId);
                                }
                            }
                        } else {
                            if (data && data.errors?.length) {
                                data.errors.map(i => Toasty.error(i));
                            }
                        }
                    }
                } catch (err) {
                    console.log(err);
                    Toasty.error('خطایی غیر‌ منتظره رخ داد')
                }
                break;
            }
            case "folder": {
                if (!folderId) return;
                try {
                    const {
                        title,
                        description,
                        isPublic,
                        isNeedToLogin,
                        price,
                        password,
                        isHaveExpire,
                        isHavePassword,
                        isFree,
                        expireDate,
                    } = inputsData;
                    const { data } = await shareFolder({
                        folderId,
                        title,
                        description,
                        isPublic,
                        password: isHavePassword ? password : undefined,
                        expireDate: isHaveExpire ? expireDate?.toISOString().slice(0, 10).replace(/-/g, "-") : undefined,
                        downloadPrice: !isFree && price,
                        isNeedRegister: isNeedToLogin,
                        ReciverNames: !isPublic ? receiversList : undefined,
                    });
                    if (data?.isSuccess) {
                        onClose();
                        const { linkAddress } = data.value;
                        setLinkAddress(linkAddress);
                        setSuccessShareModalOpen(true);
                    } else {
                        if (data && data.errors?.length) {
                            data.errors.map(i => Toasty.error(i));
                        }
                    }
                } catch (err) {
                    console.log(err);
                    Toasty.error('خطایی غیر‌ منتظره رخ داد')
                }
                break;
            }
            case "file": {
                try {
                    const {
                        title,
                        description,
                        isPublic,
                        isNeedToLogin,
                        price,
                        password,
                        isHaveExpire,
                        isHavePassword,
                        isFree,
                        expireDate,
                    } = inputsData;
                    const { data } = await shareFiles({
                        title,
                        description,
                        fileIds: files.map(i => i.id),
                        isPublic,
                        ReciverNames: !isPublic ? receiversList : undefined,
                        password: isHavePassword ? password : undefined,
                        expireDate: isHaveExpire ? expireDate?.toISOString().slice(0, 10).replace(/-/g, "-") : undefined,
                        downloadPrice: !isFree ? price : '',
                        isNeedRegister: isNeedToLogin,
                    });
                    if (data?.isSuccess) {
                        onClose();
                        const { linkAddress } = data.value;
                        setLinkAddress(linkAddress);
                        setSuccessShareModalOpen(true);
                    } else {
                        if (data && data.errors?.length) {
                            data.errors.map(i => Toasty.error(i));
                        }
                    }
                } catch (err) {
                    console.log(err);
                    Toasty.error('خطایی غیر منتظره رخ داد')
                }
                break;
            }
            default: return;
        }
        setPending(false);
    }
    const handleCopyLink = () => {
        setSuccess(true);
        navigator?.clipboard.writeText(linkAddress);
        setTimeout(() => setSuccess(false), 5000);
    }

    return (
        <>
            <StyledModal onClose={onClose} {...restProps}>
                <Paper elevation={25} sx={{ width: { xs: "90%", lg: "auto" }, minWidth: { lg: "50%" }, maxWidth: { xs: "90%", lg: "85%", xl: "75%", xxl: "65%" }, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto", }}>
                    <Typography fontSize={{ xs: ".985rem", lg: "1.1rem" }} fontWeight={500} textAlign="center">اشتراک گذاری/ارسال</Typography>
                    <Grid mt={3} container spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <Grid container spacing={1.5}>
                                <Grid item xs={12}>
                                    <TextField
                                        value={inputsData.title} onChange={handleInputChange}
                                        name="title" fullWidth required
                                        label="عنوان" placeholder="لطفا عنوان را وارد کنید" />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={inputsData.description} onChange={handleInputChange}
                                        name="description" fullWidth
                                        label="توضیحات" placeholder="لطفا توضیحات را وارد کنید"
                                        multiline minRows={4} />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox name="isPublic" checked={inputsData.isPublic} onChange={handleCheckboxChange} />}
                                            label="اشتراک گذاری عمومی" />
                                        {/*<FormControlLabel*/}
                                        {/*    control={<Checkbox name="isFree" checked={inputsData.isFree} onChange={handleCheckboxChange} />}*/}
                                        {/*    label="فایل رایگان" />*/}
                                        <Fade in={!inputsData.isFree} unmountOnExit>
                                            <TextField
                                                value={inputsData.price} onChange={handleInputChange}
                                                InputProps={{ inputComponent: NumericFormatCustom }}
                                                inputProps={{ allowLeadingZeros: false, suffix: " ریال", type: "tel" }}
                                                name="price" fullWidth required
                                                label="مبلغ" placeholder="لطفا مبلغ را وارد کنید" />
                                        </Fade>
                                        <FormControlLabel
                                            control={<Checkbox name="isHavePassword" checked={inputsData.isHavePassword} onChange={handleCheckboxChange} />}
                                            label="دارای رمز" />
                                        <Fade in={inputsData.isHavePassword} unmountOnExit>tton
                                            <TextField
                                                value={inputsData.password} onChange={handleInputChange}
                                                type={inputsData.showPassword ? 'text' : 'password'}
                                                name="password" fullWidth required
                                                label="رمز" placeholder="لطفا رمز فایل را وارد کنید"
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="start">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => setInputsData({ ...inputsData, showPassword: !inputsData.showPassword })}
                                                                onMouseDown={(e) => e.preventDefault()}
                                                                edge="end">
                                                                {inputsData.showPassword ? <VisibilityOffRounded /> :
                                                                    <VisibilityRounded />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                }} />
                                        </Fade>
                                        <FormControlLabel
                                            control={<Checkbox name="isHaveExpire" checked={inputsData.isHaveExpire} onChange={handleCheckboxChange} />}
                                            label="دارای تاریخ انقضا" />
                                        {inputsData.isHaveExpire && (
                                            <FarsiDateTimePicker
                                                value={inputsData.expireDate} onChange={(newDate) => setInputsData({ ...inputsData, expireDate: newDate })}
                                                disablePast onError={(err) => setExpireDateError(err)} />
                                        )}
                                        <FormControlLabel
                                            control={<Checkbox name="isNeedToLogin" checked={inputsData.isNeedToLogin} onChange={handleCheckboxChange} />}
                                            label="نیاز به عضویت / تایید موبایل" />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                            {
                                !showTooltip ?
                                    <Box className="MuiFileActions-root">
                                        <Tooltip title="راهنما">
                                            <IconButton onClick={(e) => {e.stopPropagation();setShowTooltip(!showTooltip);}} sx={{ p: 0 }}><QuestionMarkRounded color='inherit'/></IconButton>
                                        </Tooltip>
                                    </Box>
                                    :
                                    ''
                            }
                            {
                                showTooltip ?
                                    <Alert icon={<QuestionMark fontSize="inherit"/>}
                                           severity="info"
                                           sx={{width: 1}}
                                           action={
                                               <Button color="inherit" size="small">
                                                   <IconButton onClick={(e) => {e.stopPropagation();setShowTooltip(!showTooltip);}} sx={{ p: 0 }}><CloseRounded color='inherit'/></IconButton>
                                               </Button>
                                           }>
                                        <strong>اشتراک گذاری عمومی -></strong> در صورت انتخاب این گزینه نیازی به درج دریافت کننده نمیباشد و هر کسی که کد اشتراک گذاری را داشته باشد امکان دانلود فایل را دارد این نوع فایلها در جستجو سایت نیز برای همه قابل دسترسی است
                                        <br/>
                                        <strong>نیاز به عضویت -></strong> با انتخاب این گزینه فرد یا افرادی که به عنوان گیرنده فایل معرفی کرده اید برای دیدن فایلها باید به سایت وارد شوند
                                    </Alert>
                                    :
                                    ""
                            }
                            {/*<Alert icon={<QuestionMark fontSize="inherit"/>}*/}
                            {/*       severity="info"*/}
                            {/*       sx={{width: 1}}>*/}
                            {/*    <strong>اشتراک گذاری عمومی -></strong> در صورت انتخاب این گزینه نیازی به درج دریافت کننده نمیباشد و هر کسی که کد اشتراک گذاری را داشته باشد امکان دانلود فایل را دارد این نوع فایلها در جستجو سایت نیز برای همه قابل دسترسی است*/}
                            {/*    <br/>*/}
                            {/*    <strong>نیاز به عضویت -></strong> با انتخاب این گزینه فرد یا افرادی که به عنوان گیرنده فایل معرفی کرده اید برای دیدن فایلها باید به سایت وارد شوند*/}
                            {/*</Alert>*/}
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container spacing={1.5}>
                                <Grid item xs={12}>
                                    <Grid component="form" onSubmit={handleAddReceiver} item xs={12} container spacing={1.5}>
                                        <Grid item xs={12} lg={8}>
                                            <TextField
                                                value={inputsData.receiver} onChange={handleInputChange}
                                                error={!!receiverError} helperText={receiverError}
                                                name="receiver" fullWidth
                                                disabled={inputsData.isPublic}
                                                label="شماره همراه یا آدرس ایمیل دریافت کنندگان" placeholder="ایمیل یا شماره موبایل دریافت کننده را وارد فرمایید" />
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <Button
                                                disabled={inputsData.isPublic}
                                                type="submit" variant="contained"
                                                fullWidth disableElevation sx={{ py: 2 }}>افزودن</Button>
                                        </Grid>
                                    </Grid>
                                    <Stack mt={1.5} direction="row" alignItems="center" flexWrap="wrap" rowGap={2} columnGap={2}>
                                        {
                                            user?.creditBalance
                                                ?
                                                <Alert severity="warning" sx={{ width: 1 }}>برای ارسال پیامک اشتراک گذاری حساب شما باید دارای اعتبار باشد برای شارژ حساب <Button variant="text" onClick={() => { handleClose(); setAddBalanceModal(true) }}>اینجا</Button> کلیک کنید</Alert>
                                                :
                                                ""
                                        }
                                        {!inputsData.isPublic
                                            ?
                                            receiversList.length
                                            ?
                                            receiversList.map((r, ind) => (
                                                <Chip key={ind} label={r} onDelete={() => handleRemoveReceiver(r)} />
                                            ))
                                            :
                                            <Alert severity="info" sx={{ width: 1 }}>دریافت کننده ای انتخاب نشده <br /> شماره یا ایمیل مورد نظر را وارد کنید و اینتر را بزنید تا درج شود</Alert>
                                            :
                                            <Alert severity="info" sx={{ width: 1 }}>اشتراک گذاری عمومی نیازی به دریافت کننده ندارد</Alert>
                                        }
                                    </Stack>
                                    <Fade in={!inputsData.isPublic} unmountOnExit>
                                        <Stack mt={1.5} spacing={1}>
                                            {/*<Button fullWidth variant="contained" sx={{ py: 1.5 }} disableElevation>انتخاب از دفترچه آدرس گوشی</Button>*/}
                                            <Button onClick={() => setAddressBookModalOpen(true)} fullWidth variant="contained" sx={{ py: 1.5 }} disableElevation>انتخاب از دفترچه آدرس میلفا</Button>
                                        </Stack>
                                    </Fade>
                                </Grid>
                                <Grid item xs={12}>
                                    {files?.length
                                        ?
                                        <>
                                            <Typography fontSize="1rem" fontWeight={500} textAlign="center">{files.length.toLocaleString('fa-IR')} فایل انتخاب شده</Typography>
                                            <Stack mt={1.5} direction={{ lg: "row" }} alignItems="center" flexWrap={{ lg: "wrap" }} columnGap={2} rowGap={2}>
                                                {files.map((file, index) => (
                                                    <Chip key={index} color="secondary" label={file.name} onDelete={() => handleRemoveFile(file)} sx={{ width: { xs: 1, lg: "auto" } }} />
                                                ))}
                                            </Stack>
                                        </>
                                        :
                                        !folderId
                                            ?
                                            <Typography fontSize="1rem" fontWeight={500} textAlign="center">هیچ فایلی یافت نشد</Typography>
                                            : null}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Stack mt={3} direction={{ lg: "row" }} alignItems="center" columnGap={1} rowGap={1}>
                        <LoadingButton
                            loading={pending}
                            onClick={handleSubmit} fullWidth
                            variant="contained" sx={{ py: 1.5 }}>ارسال/اشتراک فایل</LoadingButton>
                        <Button onClick={onClose} fullWidth variant="outlined" sx={{ py: 1.5 }} disableElevation>انصراف</Button>
                    </Stack>
                </Paper>
            </StyledModal>

            {/* Login Modal */}
            <LoginModal open={loginModalOpen} onClose={() => setLoginModalOpen(false)} options={{ noReload: true, onSuccess: (e) => handleSubmit(e, true) }} />

            {/* Address Books */}
            <AddressBookModal
                open={addressBookModalOpen}
                onClose={() => setAddressBookModalOpen(false)}
                onConfirm={(receivers) => { handleAddReceivers(receivers); setAddressBookModalOpen(false) }} />

            {/* Add Balance Input */}
            <InputFieldModal
                open={addBalanceModal}
                onClose={() => setAddBalanceModal(false)}
                pending={pending}
                inputProps={{
                    label: "مبلغ", placeholder: "لطفا مبلغ مورد نظر خود را وارد کنید",
                    InputProps: { inputComponent: NumericFormatCustom },
                    inputProps: { allowLeadingZeros: false, suffix: " ریال", type: "tel" },
                }}
                onConfirm={(value) => handleGotoBalancePayment(value)} />

            {/* Success Modal */}
            <StyledModal open={successShareModalOpen && linkAddress} onClose={() => setSuccessShareModalOpen(false)}>
                <Paper elevation={25} sx={{ width: { xs: "90%", lg: "auto" }, minWidth: { lg: "50%" }, maxWidth: { xs: "90%", lg: "85%", xl: "75%", xxl: "65%" }, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto", }}>
                    <Typography fontSize={{ xs: ".985rem", lg: "1.1rem" }} fontWeight={500} textAlign="center">اشتراک گذاری/ارسال</Typography>
                    <Alert severity="success" sx={{ mt: 2 }}>فایل های مورد نظر با موفقیت اشتراک گذاری شدند</Alert>
                    <Grid mt={3} container spacing={2}>
                        <Grid item xs={12} lg={8}>
                            <Box sx={{ p: 2, borderRadius: 1, borderWidth: 1, borderStyle: "solid", borderColor: theme => theme.palette.grey.main }}>{linkAddress}</Box>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <Button
                                onClick={handleCopyLink}
                                fullWidth
                                color={success ? "success" : "primary"}
                                variant="contained"
                                disableElevation
                                startIcon={success ? <DoneRounded /> : <ContentCopyRounded />}
                                sx={{ py: 1.5, height: 1 }}
                            >{success ? "لینک با موفقیت کپی شد!" : "کپی"}</Button>
                        </Grid>
                    </Grid>
                    <Button onClick={() => setSuccessShareModalOpen(false)} variant="contained" sx={{ px: { lg: 12 }, py: 1.5, mt: 10, width: { xs: 1, lg: "auto" } }} disableElevation>بستن</Button>
                </Paper>
            </StyledModal>
        </>
    )
}
export default ShareFileModal;

const StyledModal = styled(Modal)(({ theme }) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
